import { render, staticRenderFns } from "./ChildItem.vue?vue&type=template&id=12a1832a&scoped=true&"
import script from "./ChildItem.vue?vue&type=script&lang=js&"
export * from "./ChildItem.vue?vue&type=script&lang=js&"
import style0 from "./ChildItem.vue?vue&type=style&index=0&id=12a1832a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a1832a",
  null
  
)

export default component.exports